import React, { useEffect, useState } from "react";
import PlusIcon from "assets/icon/PlusIcon";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownStatusList, EmptyString, FormTypeAdd, FormTypeEdit, ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading, ModalTypeSuccess, PageSize, PaginationBack, PaginationFirst, PaginationLast, PaginationNext, StatusCodeActive } from "utils/Constant";
import { ApiGetUserList, ApiDeleteUser, ApiCheckIsAdmin } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import EditIcon from "assets/icon/EditIcon";
import PaginationButton from "components/Input/PaginationButton";
import Dropdown from "components/Input/Dropdown";
import { CheckResponse, GetStatus } from "utils/helpers"
import RevisionIcon from "assets/icon/RevisionIcon";
import { useModal } from "components/modal/ModalContext";
import { FilterCard } from "components/Cards";
import Pagination from "components/Input/PaginationButton";
import { useCallApi } from "api/apiHooks";

export default function User(){
    let navigate = useNavigate()
    const { openModal, closeModal } = useModal()
    const { fetchUserList, fetchDeleteUser, fetchCheckIsAdmin } = useCallApi()

    const { fetch: apiDeleteUser } = useFetch(ApiDeleteUser)
    const { fetch: apiCheckIsAdmin } = useFetch(ApiCheckIsAdmin)

    const [userList, setUserList] = useState([])
    const [username, setUsername] = useState(EmptyString)
    const [name, setName] = useState(EmptyString)
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)

    // Function Grid
    async function handlePageChange(newIndex) {
        try {
            const res = await fetchUserList(username, name, status, PageSize, newIndex)

            if (CheckResponse(res)) {
                const totalData = res?.data?.totalData ?? 0;
                const total = Math.max(1, Math.ceil(totalData / PageSize));

                setUserList(res)
                setTotalPages(total);
                setPageIndex(newIndex);
            } else {
                openModal(ModalTypeFail, { message: res.message })
                return
            }
        } finally {
            closeModal();
        }
    }

    // Button Event
    const addBtnClick = () => {
        navigate("/setting/user/form?userId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (id) => {
        navigate("/setting/user/form?userId=" + id + "&formType=" + FormTypeEdit)
    }
    const deleteBtnClick = (id, status) => {
        openModal(ModalTypeConfirmation, {
            onConfirm: () => {
                openModal(ModalTypeLoading)

                fetchDeleteUser(id, status).then((res) => {
                    if (CheckResponse(res)) {
                        handlePageChange(pageIndex)
                        closeModal()
                    } else {
                        openModal(ModalTypeFail, { message: res.message })
                    }
                })
            },
        })
    }

    useEffect(() => {
        openModal(ModalTypeLoading)
        
        fetchCheckIsAdmin(localStorage.getItem("Id")).then((res) => {
            if (CheckResponse(res)) {
                if (res.data.isAdmin === false){
                    localStorage.setItem("IsAdmin", "0")
                    window.location.href = "/"
                } else {
                    handlePageChange(0)
                }
            } else {
                openModal(ModalTypeFail, { message: res.message })
            }
        })
    },[username, name, status])

    return(
        <div className="flex flex-col gap-2 p-3 sm:p-6">
            <div >
                <span className="font-semibold text-2xl">User</span>
            </div>
            <hr />

            <div className="flex flex-col sm:flex-row justify-between gap-8 mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                    <FilterCard title='Username' width={'w-72'}>
                        <input className="input" value={username} onChange={(e) => { setUsername(e.target.value) }} />
                    </FilterCard>
                    <FilterCard title='Name' width={'w-72'}>
                        <input className="input" value={name} onChange={(e) => { setName(e.target.value) }} />
                    </FilterCard>
                    <FilterCard title='Status' width={'w-32'}>
                        <Dropdown value={status} options={DropdownStatusList} onChange={(e) => { setStatus(e.value) }} placeholder={"All"} />
                    </FilterCard>
                </div>
            </div>

            <div className="flex w-full justify-end">
                <button className="button flex gap-2" onClick={addBtnClick}>
                    <PlusIcon />
                    <span>Add</span>
                </button>
            </div>
           
            <div className="mt-2 overflow-hidden sm:border sm:rounded-3xl sm:shadow-sm">
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-11">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2">Username</th>
                            <th className="font-semibold text-left px-2">Name</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Status</th>
                            <th className="font-semibold w-auto sm:w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        { userList?.data?.listData?.map((data, i) => {
                            return(
                                <tr className="my-1 row border-y hover:bg-slate-100" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2">
                                        <span>{ data.username }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.fullName }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                        <button className="button flex gap-2" onClick={() => editBtnClick( data.userId )}>
                                            <EditIcon className="w-3 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2`} onClick={() => deleteBtnClick( data.userId, data.status )}>
                                            {data.status === StatusCodeActive ? (<TrashIcon className="w-3 fill-white" />) : (<RevisionIcon className="w-3 fill-white" />)}
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <Pagination
                pageIndex={pageIndex}
                totalPages={totalPages}
                onPageChange={handlePageChange}
            />
        </div>
    )
}